import { render } from "./collapse.vue?vue&type=template&id=5b3beaf0&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=5b3beaf0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b3beaf0"

export default script